import {useCallback, useRef} from 'react'

export function useSafeFlowAction() {
  const intervalID = useRef<number | null>(null)

  const handleSafeFlowWindow = useCallback((safeFlowWindow: Window | null) => {
    intervalID.current = window.setInterval(() => {
      const isRedirected = !safeFlowWindow?.closed && safeFlowWindow?.location?.origin === window.location.origin
      if (isRedirected) {
        safeFlowWindow?.close()
      }

      if (safeFlowWindow?.closed) {
        if (intervalID.current) {
          clearInterval(intervalID.current)
        }
      }
    }, 100)
  }, [])

  return useCallback(
    (url: string) => {
      const safeFlowWindow = window.open(url, 'safe-flow')
      handleSafeFlowWindow(safeFlowWindow)
    },
    [handleSafeFlowWindow],
  )
}
